import { authHttp } from '../http'
import { errorHandler } from '../../../util/error.service'
import { CONFIG } from '../../../../config'
import {
  parseToMysqlFormatWithTime00,
  parseToMysqlFormatWithTime23,
} from '../../../util/date.service'
import { openReportInNewTab } from '../../../util/report.service'
import axios from 'axios'

const { ENVIROMENT } = CONFIG
const DOC_BASE_URL = `${CONFIG[ENVIROMENT]['DOCS_END_POINT']}`

const MovimentacaoRecebimentoHttp = {
  baseURL: `${CONFIG[ENVIROMENT]['MAIN_END_POINT']}/patrimonio`,

  async saveMovimentacao(movimentacao) {
    try {
      const url = this.baseURL + '/movimentacao-recebimento'
      const response = await authHttp().post(url, movimentacao)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async updateMovimentacao(movimentacao) {
    try {
      const url = this.baseURL + '/update/movimentacao-recebimento'
      const response = await authHttp().put(url, movimentacao)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async saveMovimentacaoMassively(movimentacao) {
    try {
      const url = this.baseURL + '/movimentacao-recebimento-massively'
      const response = await authHttp().post(url, movimentacao)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getMovimentacoesRecebimento(dataInicial, dataFinal, selectedTp) {
    try {
      const pInicial = parseToMysqlFormatWithTime00(dataInicial)
      const pFinal = parseToMysqlFormatWithTime23(dataFinal)

      const url =
        this.baseURL +
        `/movimentacao-recebimento?pInicial=${pInicial}&pFinal=${pFinal}&tpId=${selectedTp}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  emitirComprovante(movimentacaoRecebimentoId) {
    const url =
      this.baseURL +
      `/movimentacao-recebimento/emitir-comprovante/${movimentacaoRecebimentoId}?t=${localStorage.getItem('t')}`
    openReportInNewTab(url)
  },

  async getMovimentacaoRecebimentoById(movimentacaoRecebimentoId) {
    try {
      const url = this.baseURL + `/movimentacao-recebimento/${movimentacaoRecebimentoId}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async updatePathComprovante(movimentacaoRecebimentoId, pathComprovante) {
    try {
      const url =
        this.baseURL +
        `/movimentacao-recebimento/update-path-comprovante/${movimentacaoRecebimentoId}`
      const response = await authHttp().put(url, { path_comprovante: pathComprovante })
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async deleteComprovanteFile(filename) {
    try {
      const url = `${DOC_BASE_URL}/patrimonio-recebimento/${filename}`
      const response = await axios.delete(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  urlUploadComprovante(movimentacaoRecebimentoId) {
    return `${DOC_BASE_URL}/patrimonio-recebimento/${movimentacaoRecebimentoId}`
  },
}

export default MovimentacaoRecebimentoHttp
